module.exports = __webpack_public_path__ + "static/media/DaysOff2.6acc2b6d.png";